import React from "react";

function TermsOfService() {
  return (
    <div>
      <iframe
        src="https://docs.google.com/document/d/e/2PACX-1vROt9QdtAuJlUdSPfwZ175C3DwVWFxYbCYnPegdDdrTuG6CpOjxS_jMJ3IBEH3FQw/pub?embedded=true"
        width="800px"
        height="14550px"
        title="Terms of Service"
      />
    </div>
  );
}

function CopyrightPolicy() {
  return (
    <div>
      <iframe
        src="https://docs.google.com/document/d/e/2PACX-1vSJnndumXoVK1LN-8DKe8TdzZiFqdZpX21zk1ehqpW1yb99tk413U-XBbyly3WqIw/pub?embedded=true"
        width="800px"
        height="4050px"
        title="Copyright Policy"
      />
    </div>
  );
}

function PrivacyPolicy() {
  return (
    <div>
      <iframe
        src="https://docs.google.com/document/d/e/2PACX-1vRjkVZ0YcniAA8b3Nc4gyYlUnw9eQ4F-IBmpxFqOrEDByfDZSoNaoPibrpX9BOTjw/pub?embedded=true"
        width="800px"
        height="6000px"
        title="Privacy Policy"
      />
    </div>
  );
}

export { TermsOfService, CopyrightPolicy, PrivacyPolicy };
